<template>
  <b-row>
    <b-col cols="12" lg="6">
      <b-card no-header>
        <template slot="header">CPF: {{ $route.params.id }}</template>
        <b-table
          striped
          small
          fixed
          bordered
          responsive="sm"
          :items="items($route.params.id)"
          :fields="fields"
        >
          <template v-slot:cell(value)="data">
            <strong>{{data.item.value}}</strong>
          </template>
        </b-table>
        <template slot="footer">
          <b-button @click="goBack">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import itens from "./ClientesData";
export default {
  name: "cliente",
  props: {
    caption: {
      type: String,
      default: "cliente id"
    }
  },
  data: () => {
    return {
      items: id => {
        const cliente = clientesData.find(
          cliente => cliente.id.toString() === id
        );
        const clienteDetails = cliente
          ? Object.entries(cliente)
          : [["id", "Not found"]];
        return clienteDetails.map(([item, detalhe]) => {
          return { item: item, detalhe: detalhe };
        });
      },
      fields: [{ key: "item" }, { key: "detalhe" }]
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>